import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'antd/dist/reset.css'
import AuthProvider from 'services/AuthProvider';

import { getApps, initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { API_BASE_URL } from 'configs/AppConfig';
import { AUTH_TOKEN, AUTH_USER } from 'constants/AuthConstant';
import { notification } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

// Sound playback control
let lastPlayed = 0;
const NOTIF_THROTTLE_MS = 2000;

const colorThemes = {
  blue: {
    bg: '#e6f4ff',
    text: '#0050b3',
    border: '#1890ff',
    icon: '#1890ff',
  },
  red: {
    bg: '#fff1f0',
    text: '#a8071a',
    border: '#ff4d4f',
    icon: '#ff4d4f',
  },
  yellow: {
    bg: '#fffbe6',
    text: '#ad8b00',
    border: '#faad14',
    icon: '#faad14',
  },
  orange: {
    bg: '#fff7e6',
    text: '#d46b08',
    border: '#fa8c16',
    icon: '#fa8c16',
  },
  green: {
    bg: '#f6ffed',
    text: '#237804',
    border: '#52c41a',
    icon: '#52c41a',
  },
  purple: {
    bg: '#f9f0ff',
    text: '#531dab',
    border: '#9254de',
    icon: '#9254de',
  }
};

window.playNotificationSound = () => {
  const now = Date.now();
  if (now - lastPlayed < NOTIF_THROTTLE_MS) return;

  let playCount = 0;
  const maxLoops = 3;
  const soundSrc = '/notification.mp3';
  const audioPlayers = [];

  const playSound = () => {
    const audio = new Audio(soundSrc);
    audio.volume = 1.0;
    audio.play().catch(err => console.warn('🔇 Failed to play sound:', err));
    audioPlayers.push(audio);
  };

  // Play the first sound immediately
  playSound();
  playCount++;

  const interval = setInterval(() => {
    if (playCount >= maxLoops) {
      clearInterval(interval);
      removeListeners();
      return;
    }
    playSound();
    playCount++;
  }, 5000);

  // Stop playback early on user interaction
  const stopPlayback = () => {
    clearInterval(interval);
    audioPlayers.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
    });
    removeListeners();
  };

  const removeListeners = () => {
    document.removeEventListener('click', stopPlayback);
    document.removeEventListener('keydown', stopPlayback);
    document.removeEventListener('touchstart', stopPlayback);
  };

  document.addEventListener('click', stopPlayback);
  document.addEventListener('keydown', stopPlayback);
  document.addEventListener('touchstart', stopPlayback);

  lastPlayed = now;
};

const firebaseConfig = {
  apiKey: "AIzaSyA11JkcwX6yFVHXA5cb-tDj565mc0UBe-0",
  authDomain: "spka-bomba.firebaseapp.com",
  projectId: "spka-bomba",
  storageBucket: "spka-bomba.firebasestorage.app",
  messagingSenderId: "376643235648",
  appId: "1:376643235648:web:5d2e52653ab84760fd94a5",
  measurementId: "G-6R3FL10HFR"
};

const firebaseApp = getApps().length === 0 
  ? initializeApp(firebaseConfig) 
  : getApps()[0];
const messaging = getMessaging(firebaseApp);

// Register the Service Worker and listen to messages
navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    console.log('✅ Service Worker registered.');

    // Foreground message handler
    onMessage(messaging, (payload) => {
      console.log('📥 Foreground message received:', payload);

      const user = JSON.parse(localStorage.getItem(AUTH_USER));
      const currentUserId = user?.id;
      const payloadUserId = payload.data?.user_id;
      
      const colorKey = payload.data?.bg_color?.toLowerCase() || 'orange'; // default
      const theme = colorThemes[colorKey] || colorThemes.orange;

      if (payloadUserId?.toString() === currentUserId?.toString()) {
        const { title, body } = payload.notification;

        notification.open({
          message: <span style={{ color: theme.text }}>{title}</span>,
          description: <span style={{ color: theme.text }}>{body}</span>,
          icon: <ExclamationCircleOutlined style={{ color: theme.icon, fontSize: 20 }} />,
          style: {
            borderLeft: `4px solid ${theme.border}`,
            backgroundColor: theme.bg,
          },
          duration: 0,
          placement: 'topRight',
        });

        // Play sound
        window.playNotificationSound?.();

        // Redirect to pengawasan
        window.dispatchEvent(new CustomEvent('navigateToPengawasan'));
      } else {
        console.log(`🔕 Notification ignored (not for current user)`);
      }

      const event = new CustomEvent('newNotification', { detail: payload });
      window.dispatchEvent(event);
    });
  }).catch((error) => {
    console.error('❌ Service Worker registration failed:', error);
  });

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <React.StrictMode>
        <AuthProvider>
            <App />
        </AuthProvider>   
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
